module.exports = __webpack_public_path__ + "img/icn-02.fd24d9df.png";